/** Same-site relative paths only. Payment success does not open the draw. */
export function safeInternalPath(raw, fallback = '/app') {
  if (typeof raw !== 'string') return fallback;
  const text = raw.trim();
  if (!text.startsWith('/') || text.startsWith('//') || text.startsWith('/\\')) return fallback;
  if (/[\\\n\r\t]/.test(text) || text.includes('://')) return fallback;
  const path = text.split('?')[0].replace(/\/$/, '') || '/';
  if (path === '/lifetime-draw') return fallback;
  return text;
}
